import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faBellSlash,
    faBuilding,
    faExternalLink,
    faFileLines,
    faRobot,
    faEdit,
    faTimesCircle,
    faCheckCircle,
    faListOl,
    faCaretDown,
    faCheck,
    faCog,
    faQuestionCircle,
    faCogs,
    faColumns,
    faTimes,
    faEllipsisV,
    faEnvelope,
    faChevronRight,
    faChevronLeft,
    faExclamationCircle,
    faExclamationTriangle,
    faEye,
    faLink,
    faPhone,
    faPowerOff,
    faSearch,
    faStroopwafel,
    faSyncAlt,
    faTags,
    faUnlink,
    faUser,
    faHandshake,
    faFileExport,
    faUserEdit,
    faUserPlus,
    faPlus,
    faUsers,
    faQuestion,
    faPencilAlt,
    faCopy,
    faChevronDown, faTrash, faPlusSquare, faMinusSquare, faUniversalAccess, faChartLine,
    faBinoculars,
    faFileExcel,
    faStar,
    faArrowLeft, faArrowRight, faEquals, faTable, faBan, faInfoCircle,
    faExpand,
    faUserShield, faExchangeAlt,
    faWandMagicSparkles,
    faBook,
    faCirclePlus,
    faChartBar,
    faMicrochip,
    faComments,
    faPlug,
    faCode,
    faTerminal,
    faShuffle,
    faGear,
    faHandPointer,
    faGift,
    faGaugeHigh,
    faBullseye,
    faTableCellsLarge,
    faBell,
    faChartPie,
    faMagnifyingGlassChart,
    faXmark,
    faBolt,
    faLayerGroup,
    faLock,
    faCrown,
    faFilter,
    faEyeSlash,
    faDollarSign
} from '@fortawesome/free-solid-svg-icons';

import {faGoogle, faFacebook} from '@fortawesome/free-brands-svg-icons';
import {faDownload} from '@fortawesome/free-solid-svg-icons';

export function initIconsLibrary() {
    library.add(
        faStroopwafel,
        faUserPlus,
        faPlus,
        faHandshake,
        faUserEdit,
        faFileExport,
        faCheck,
        faCaretDown,
        faColumns,
        faEllipsisV,
        faUnlink,
        faLink,
        faTags,
        faSyncAlt,
        faBellSlash,
        faChevronRight,
        faChevronLeft,
        faExclamationTriangle,
        faBuilding,
        faRobot,
        faEdit,
        faCheckCircle,
        faTimesCircle,
        faListOl,
        faUsers,
        faUser,
        faTimes,
        faCogs,
        faQuestionCircle,
        faCog,
        faSearch,
        faExclamationCircle,
        faPowerOff,
        faEnvelope,
        faEye,
        faPhone,
        faFacebook,
        faGoogle,
        faDownload,
        faQuestion,
        faPencilAlt,
        faCopy,
        faChevronDown,
        faTrash,
        faPlusSquare,
        faMinusSquare,
        faUniversalAccess,
        faChartLine,
        faBinoculars,
        faFileExcel,
        faStar,
        faArrowLeft,
        faArrowRight,
        faEquals,
        faTable,
        faBan,
        faInfoCircle,
        faExpand,
        faUserShield,
        faExchangeAlt,
        faFileLines,
        faExternalLink,
        faWandMagicSparkles,
        faBook,
        faCirclePlus,
        faChartBar,
        faMicrochip,
        faComments,
        faPlug,
        faCode,
        faTerminal,
        faShuffle,
        faGear,
        faHandPointer,
        faGift,
        faGaugeHigh,
        faBullseye,
        faTableCellsLarge,
        faBell,
        faChartPie,
        faMagnifyingGlassChart,
        faXmark,
        faBolt,
        faLayerGroup,
        faLock,
        faCrown,
        faFilter,
        faEyeSlash,
        faDollarSign
    );
}
